export default function HEALRepair({ children }) {
  return (
    <>
      <p>
        Want to know what design has to do with mental or emotional wellbeing, grief, depression, or
        substance use? Want to hear about the thinking behind the designs? Join us for the Friday
        Late programme Re:Repair+ on 27 Sep 2024 at 42 Waterloo Street for casual discussions about
        approaching brokenness with empathetic design. Sign up for one of two sessions from
        7.30pm-8.00pm or from 9.00-9.30pm. The local designers involved in the repair of items and
        some members of the creative and production team will share their experiences and chat about
        the approaches taken, the observations made, and the revelations and challenges encountered.
        See the repaired objects and linger to mingle and experience the healing power of design!
      </p>
      {children}
    </>
  );
}
